import {SvgIcon, Box, Chip, Zoom} from "@mui/material";


export const HaccpIcon = (props) => {
  
  return (
    <SvgIcon {...props} viewBox="96.512 86.692 144.931 42.704">
      <path d="M 29.358 102.293 L 32.011 85.541 L 26.7 85.541 L 24.047 102.293 L 12.879 102.293 L 19.415 61.014 L 30.583 61.014 L 28.243 75.796 L 33.553 75.796 L 35.894 61.014 L 47.062 61.014 L 40.526 102.293 L 29.358 102.293 Z M 94.568 73.282 C 93.222 71.749 92.047 70.873 89.748 70.873 C 83.945 70.873 81.507 77.279 80.788 81.823 C 80.025 86.64 80.477 92.772 86.063 92.772 C 88.581 92.772 90.325 91.787 92.391 90.145 L 89.905 101.697 C 87.505 102.681 85.401 103.176 82.937 103.176 C 73.795 103.176 67.121 96.222 69.357 82.097 C 72.287 63.593 85.482 60.472 90.902 60.472 C 92.873 60.472 94.746 60.745 96.439 61.457 L 94.568 73.282 Z M 123.802 73.282 C 122.456 71.749 121.281 70.873 118.982 70.873 C 113.179 70.873 110.742 77.279 110.023 81.823 C 109.259 86.64 109.712 92.772 115.296 92.772 C 117.814 92.772 119.558 91.787 121.624 90.145 L 119.138 101.697 C 116.738 102.681 114.634 103.176 112.171 103.176 C 103.028 103.176 96.355 96.222 98.591 82.097 C 101.521 63.593 114.716 60.472 120.136 60.472 C 122.107 60.472 123.98 60.745 125.673 61.457 L 123.802 73.282 Z M 125.806 102.462 L 132.341 61.183 L 142.525 61.183 C 152.269 61.183 159.267 64.358 157.55 75.198 C 155.853 85.928 148.763 89.213 139.114 88.94 L 136.973 102.462 L 125.806 102.462 Z M 142.927 70.052 L 142.097 70.106 L 140.589 79.632 C 143.628 79.797 145.814 78.099 146.298 75.034 C 146.716 72.406 145.663 70.052 142.927 70.052 Z M 61.387 61.207 L 57.775 61.207 L 52.586 73.345 L 52.071 88.108 L 46.276 88.108 L 42.375 97.233 L 51.976 97.233 L 52.071 102.462 L 63.668 102.462 L 61.387 61.207 Z" fillRule="evenodd" clipRule="evenodd" transform="matrix(1, 0, 0, 1, 83.633392, 26.220093)" />
    </SvgIcon>
  );
}

export const HelpIcon = ({tourStarted, stopTour}) => {

  return (
    <Zoom in={tourStarted}>
      <Box>
        <Chip
              label="Tour di aiuto attivo"
              onDelete={stopTour}
              color="primary"
              variant="outlined"/>
      </Box>
    </Zoom>
  );
}
